import React, { Fragment, useState } from "react";
import Breadcrumb from "../../common/breadcrumb";
import MenuItem from "@mui/material/MenuItem";
import { Card, CardBody, Container, Row } from "reactstrap";

import { Button, Typography } from "@mui/material";
import { Grid, TextField } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";

import {
  Add,
  PersonSearch,
  Refresh,
  SimCardDownloadRounded,
} from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import CommonAccordion from "../../common/commonAccordion";
import CommonTable from "../../common/commonTable";
import {
  balanceConfirmationTableData,
  balanceConfirmationTableHeader,
} from "../../common/commonConstant";
import { useEffect } from "react";
import {
  exportToExcelBalanceConfirmation,
  getAllBalanceConfirmation,
  getAllRegionMasters,
  getAllStateMasters,
  getBalanceConfirmationDtlByHdrId,
  resetBalanceConfirmation,
  searchBalanceConfirmationData,
} from "../../api/service";
import CommonLoader from "../../common/commonLoader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useCustomerCode } from "../../context/CustomerCodeProvider";
import BalanceConfirmationModal from "./balanceConfirmationModal";
import CommonDialog from "../../common/commonDialog";

const useStyles = makeStyles((theme) => ({
  btnClass: {
    padding: "0.5rem 1.5rem!important",
    fontWeight: 600,
  },

  btnJust: {
    display: "flex!important",
    justifyContent: "end!important",
  },

  cardbody: {
    padding: `${theme.spacing(1.8, 1.3)} !important`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(0)} !important`,
      margin: `${theme.spacing(0, 1)} !important`,
    },
  },

  muiGrid: {
    marginTop: "-2vh",
    [theme.breakpoints.down("sm")]: {
      lineHeight: 5,
    },
  },
}));

const BalanceConfirmation = () => {
  const classes = useStyles();
  const history = useNavigate();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [totalRecord, setTotalRecord] = React.useState(0);

  const [data, setData] = useState([]);
  const [modalData, setModalData] = useState([]);

  const [searchRegion, setSearchRegion] = useState([]);
  const [searchState, setSearchState] = useState([]);

  const [loading, setLoading] = useState(false);
  const [showResetPopup, setShowResetPopup] = useState(false);
  const [resetData, setResetData] = useState({});

  const isDistributorUser =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 0;

  const filterInitialValues = {
    searchCustomerCode: "",
    searchRegion: "",
    searchState: "",
    searchStatus: "",
    searchFinancialYear: "2025-26",
    //searchFinancialYear: !isDistributorUser ? "2024-25" : "",
  };

  const [selectedItemBCStatus, setSelectedItemBCStatus] = useState(null);

  const BALANCE_CONFIRMATION_STATUS = [
    {
      value: "Pending",
      label: "Pending",
    },
    {
      value: "Agreed",
      label: "Agreed",
    },
    {
      value: "Disagreed",
      label: "Disagreed",
    },
  ];

  const [searchData, setSearchData] = useState(filterInitialValues);

  const { selectedCustomerCode } = useCustomerCode();
  const isAsmUser =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 5;
  const isAgentUser =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 11; //AGENT;
  const isAdminUser =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 1;

  const onFilterInputChange = (event) => {
    const { name, value } = event.target;
    searchData[name] = value;
    setSearchData({ ...searchData });
  };

  useEffect(() => {
    loadListData();
  }, []);

  const loadListData = () => {
    setLoading(true);
    getAllBalanceConfirmation(
      page,
      rowsPerPage,
      searchData.searchFinancialYear
    ).then((res) => {
      setLoading(false);
      setData(res.response.responseObject);
      setTotalRecord(res.response.responseMap.totalCount);
    });

    getAllRegionMasters(page, rowsPerPage).then((res) => {
      setSearchRegion(res.response.responseObject);
    });

    getAllStateMasters(page, rowsPerPage).then((res) => {
      setSearchState(res.response.responseObject);
    });
  };

  const [open, setOpen] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllBalanceConfirmation(
      newPage,
      rowsPerPage,
      searchData.searchFinancialYear
    ).then((res) => {
      setData(res.response.responseObject);
      setTotalRecord(res.response.responseMap.totalCount);
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
    getAllBalanceConfirmation(
      0,
      event.target.value,
      searchData.searchFinancialYear
    ).then((res) => {
      setData(res.response.responseObject);
      setTotalRecord(res.response.responseMap.totalCount);
    });
  };

  const filterData = () => {
    setLoading(true);
    searchData.searchCustomerCode = selectedCustomerCode;
    searchBalanceConfirmationData(searchData, page, rowsPerPage).then((res) => {
      setLoading(false);
      setData(res.responseMap.data);
      setTotalRecord(res.responseMap.totalCount);
    });
  };

  const exportData = () => {
    setLoading(true);
    exportToExcelBalanceConfirmation(
      selectedCustomerCode,
      moment(new Date()).format("DD_MM_YYYY_HH_MM_SS"),
      searchData.searchFinancialYear
    ).then(() => {
      setLoading(false);
    });
  };

  const [openModal, setOpenModal] = useState(false);
  const onOpenPopup = (data) => {
    setSelectedItemBCStatus(data.balanceConfirmationStatus);
    setLoading(true);
    getBalanceConfirmationDtlByHdrId(data.balanceConfirmationId).then((res) => {
      data.claimDetails = res.response.responseObject;
      setModalData(data);
      setOpenModal(true);
      setLoading(false);
    });
  };

  const openResetModal = (data) => {
    setResetData(data);
    setShowResetPopup(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    loadListData();
  };

  const resetBalanceConfirmationData = () => {
    console.log(resetData);
    resetBalanceConfirmation(resetData).then((res) => {
      handleCloseResetModal();
      loadListData();
      toast.success("Balance confirmation resetted successfully!", {
        autoClose: 1000,
      });
    });
  };

  const handleCloseResetModal = () => {
    setShowResetPopup(false);
    setResetData({});
  };

  return (
    <Fragment>
      {loading ? <CommonLoader /> : null}
      <Breadcrumb
        title="Balance Confirmation"
        parent={
          !isAsmUser &&
          !isAgentUser &&
          !isDistributorUser && (
            <div className={classes.btnJust}>
              <Button
                color={"secondary"}
                variant="contained"
                type="button"
                className={`${classes.btnClass}`}
                // startIcon={<Add></Add>}
                onClick={() =>
                  history(
                    `${process.env.PUBLIC_URL}/master/balanceConfirmationReport`
                  )
                }
              >
                Consolidate Report
              </Button>
            </div>
          )
        }
      />
      {/* <!-- Container-fluid starts--> */}
      <Container fluid={true}>
        <Row>
          <CommonAccordion accordionTitle={"Advanced Search"}>
            <Grid
              container
              columnSpacing={2}
              rowSpacing={2}
              className={classes.muiGrid}
            >
              <Grid item sm={4} xs={12}>
                <TextField
                  fullWidth
                  label="Financial Year"
                  size="small"
                  select
                  id="fullWidth"
                  name="searchFinancialYear"
                  value={searchData.searchFinancialYear}
                  onChange={onFilterInputChange}
                >
                  <MenuItem value="2023-24">FY-2023-24</MenuItem>
                  <MenuItem value="2024-25">FY-2024-25</MenuItem>
                  <MenuItem value="2025-26">FY-2025-26</MenuItem>
                </TextField>
              </Grid>
              {!isDistributorUser && (
                <Grid item sm={4} xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-select-currency"
                    select
                    label="Region"
                    size="small"
                    name="searchRegion"
                    value={searchData.searchRegion}
                    onChange={onFilterInputChange}
                  >
                    {searchRegion.map((option) => (
                      <MenuItem
                        key={option.regionMasterId}
                        value={option.regionMasterId}
                      >
                        {option.regionName}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
              {!isDistributorUser && (
                <Grid item sm={4} xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-select-currency"
                    select
                    label="State"
                    size="small"
                    name="searchState"
                    value={searchData.searchState}
                    onChange={onFilterInputChange}
                  >
                    {searchState.map((option) => (
                      <MenuItem
                        key={option.stateMasterId}
                        value={option.stateMasterId}
                      >
                        {option.stateName}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
              <Grid item sm={4} xs={12}>
                <TextField
                  fullWidth
                  id="outlined-select-currency"
                  select
                  label="Status"
                  size="small"
                  name="searchStatus"
                  value={searchData.searchStatus}
                  onChange={onFilterInputChange}
                >
                  {BALANCE_CONFIRMATION_STATUS.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                sm={3}
                xs={12}
                sx={{
                  margin: "auto",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  type="button"
                  className={classes.btnClass}
                  onClick={() => filterData()}
                >
                  <PersonSearch></PersonSearch>
                </Button>
                <Button
                  color="primary"
                  sx={{ marginLeft: 1 }}
                  variant="contained"
                  type="button"
                  className={classes.btnClass}
                  onClick={() => {
                    setSearchData(filterInitialValues);
                    loadListData();
                  }}
                >
                  <Refresh></Refresh>
                </Button>
                {!isDistributorUser && (
                  <Button
                    color="primary"
                    sx={{ marginLeft: 1 }}
                    variant="contained"
                    type="button"
                    className={classes.btnClass}
                    onClick={() => {
                      exportData();
                    }}
                  >
                    <SimCardDownloadRounded></SimCardDownloadRounded>
                  </Button>
                )}
              </Grid>
            </Grid>
          </CommonAccordion>
          <Card>
            <CardBody className={classes.cardbody}>
              <div>
                <CommonTable
                  editMode={isDistributorUser}
                  tableData={data}
                  tableHeaders={balanceConfirmationTableHeader}
                  tableColumns={balanceConfirmationTableData}
                  editId={"balanceConfirmationId"}
                  rowsPerPageOptions={[25, 50, 100]}
                  count={totalRecord}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{ float: "right" }}
                  showPdf={true}
                  from={"Balance Confirmation"}
                  onOpenModal={onOpenPopup}
                  showFileDownload={true}
                  showReset={isAdminUser}
                  openResetModal={openResetModal}
                />
              </div>
            </CardBody>
          </Card>
        </Row>

        <BalanceConfirmationModal
          open={openModal}
          handleClose={handleCloseModal}
          setData={setModalData}
          data={modalData}
          showSubmitButton={selectedItemBCStatus === "Pending"}
          selectedItemBCStatus={selectedItemBCStatus}
        />
        <CommonDialog
          open={showResetPopup}
          title="Reset Balance Confirmation"
          onCancel={() => {
            handleCloseResetModal();
          }}
          primaryButtonLabel={"Yes"}
          secondaryButtonLabel={"No"}
          onSave={() => {
            resetBalanceConfirmationData();
          }}
        >
          <Typography variant="body1">
            Do you want to reset balance confirmation for this customer?
          </Typography>
        </CommonDialog>
      </Container>
      {/* <!-- Container-fluid Ends--> */}
      <ToastContainer autoClose={1000} />
    </Fragment>
  );
};

export default BalanceConfirmation;
